import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type Vehicle } from '@/types/Vehicle'
import { vehicleService } from '@/services/vehicleService'

export const useVehicleStore = defineStore('vehicleStore', () => {
  const vehicles = ref<Vehicle[]>([])

  const getVehicleById = async (id: string) => {
    const match = vehicles.value.find((v) => v.id === id)
    if (match) return match
    const result = await vehicleService.get(id)
    if (result) vehicles.value.push(result)
    return result
  }

  const findOrFetchByTag = async (tag: string) => {
    const localMatch = vehicles.value.filter((v) => v.tagNumber === tag)
    if (localMatch.length > 0) return localMatch
    const remoteMatches = await vehicleService.queryByTag(tag)
    vehicles.value.push(...remoteMatches)
    return remoteMatches
  }

  const add = async (vehicle: Vehicle): Promise<Vehicle> => {
    const added = await vehicleService.add(vehicle)
    vehicles.value.push(added)
    return added
  }

  const update = async (vehicle: Vehicle): Promise<Vehicle> => {
    const updated = await vehicleService.update(vehicle)
    const idx = vehicles.value.findIndex((v) => v.id === vehicle.id)
    if (idx !== -1) vehicles.value[idx] = updated
    return updated
  }

  const remove = async (id: string) => {
    await vehicleService.delete(id)
    vehicles.value = vehicles.value.filter((v) => v.id !== id)
  }

  return { vehicles, getVehicleById, findOrFetchByTag, add, update, remove }
})
